import React from "react";
import PropTypes from "prop-types";

import { DEFAULT_CARD_HEIGHT } from "config/constants";
import SectionStreamWrapper from "stream/containers/SectionStreamWrapper";
import Stream from "stream/containers/Stream";
import FullStoryCard from "cards/containers/FullStoryCard";
import Ad from "components/Library/Ad";

export default function SectionStream(props) {
  return (
    <SectionStreamWrapper {...props}>
      {({ streamParams, parsedQs }) => {
        return (
          <React.Fragment>
            {/* Display ad first in stream if queryparam exists */}
            {parsedQs.adid && (
              <Ad
                slotSize="fluid"
                renderWhenViewable={false}
                collapseEmptyDiv={true}
                targeting={{ adid: parsedQs.adid }}
              />
            )}
            <Stream
              {...streamParams}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD} 
              contentComponent={FullStoryCard}
            />
          </React.Fragment>
        );
      }}
    </SectionStreamWrapper>
  );
}

SectionStream.propTypes = {
  slug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
